import React, { Component } from 'react'
import Dashboard from './Dashboard'
import { isEmpty, pick } from 'lodash'
import { message } from 'antd'
import Transactions from '../../../api/Finance/Transactions'
import { dateVal } from '../../../modules/Utils'

class DashboardCont extends Component {
  state = {
    accounts: [],
    //company: 'members/9725112027133',
  }

  componentDidMount() {
    this.fetch(this.state.company)
  }

  api = new Transactions()
  fetch = async company => {
    if (!isEmpty(company))
      try {
        this.setState({
          fetching: true,
          company,
        })
        const accounts = await this.api.accounts(company)
        this.setState({
          accounts,
          fetching: false,
        })
      } catch (e) {
        message.error(e.errorMessage)
        this.setState({
          fetching: false,
        })
      }
  }
  onChangeCompany = async company => {
    await this.fetch(company)
  }
  onShowStatement = st => {
    const statement = { ...st }
    statement.date = dateVal(statement, 'date')
    statement.period = [dateVal(statement, 'period.start'), dateVal(statement, 'period.end')]
    this.setState({
      statement,
      visibleStatement: true,
    })
  }
  onCancelStatement = () => {
    this.setState({
      visibleStatement: false,
      statement: {},
    })
  }
  onShowTransaction = transaction => {
    this.setState({
      transaction,
      visibleTransaction: true,
    })
  }
  onCancelTransaction = () => {
    this.setState({
      visibleTransaction: false,
      statement: {},
    })
  }

  render() {
    return (
      <Dashboard
        {...this.state}
        {...pick(this, [
          'onChangeCompany',
          'fetch',
          'onShowStatement',
          'onCancelStatement',
          'onShowTransaction',
          'onCancelTransaction',
        ])}
      />
    )
  }
}

DashboardCont.propTypes = {}
DashboardCont.defaultProps = {}

export default DashboardCont
